import { Box, Typography } from '@mui/material';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';

import { PRIMARY_BUTTON_SX } from '../Samples/SampleBanner';
import { STRIP_SX } from './MatchesCallout';
import { setAsideCopy } from './matchRows';
import type { SetAsideFile } from './matchesApi';
import { CONTACT_FLASHLIGHT_URL, DATA_REVIEW } from './dataReviewTokens';

export function SetAsideWarning({ file, userId }: { file: SetAsideFile; userId: string }) {
  const copy = setAsideCopy(file);
  return (
    <Box role="status" data-testid="set-aside-warning" sx={STRIP_SX}>
      <WarningAmberRoundedIcon sx={{ alignSelf: 'flex-start', flexShrink: 0, width: 24, height: 24, color: DATA_REVIEW.stripIcon }} />
      <Box sx={{ flex: '1 1 auto', minWidth: 0, display: 'flex', flexDirection: 'column', gap: '2px' }}>
        <Typography component="b" sx={{ fontSize: 16, lineHeight: '24px', fontWeight: 700, overflowWrap: 'anywhere' }}>
          {copy.title}
        </Typography>
        <Typography component="span" sx={{ fontSize: 15, lineHeight: '22px', overflowWrap: 'anywhere' }}>
          {copy.body}
        </Typography>
      </Box>
      {copy.contact && (
        <Box
          component="a"
          href={`${CONTACT_FLASHLIGHT_URL}${encodeURIComponent(userId)}`}
          target="_blank"
          rel="noopener noreferrer"
          sx={{ ...PRIMARY_BUTTON_SX, flexShrink: 0 }}
        >
          Contact Flashlight
        </Box>
      )}
    </Box>
  );
}

export function SetAsideWarnings({ files, userId }: { files: SetAsideFile[]; userId: string }) {
  if (files.length === 0) return null;
  return (
    <>
      {files.map((file) => (
        <SetAsideWarning key={file.uploadId} file={file} userId={userId} />
      ))}
    </>
  );
}
